export enum ActionSteps {
    PRIMARY_START = 0,
    RESIDENCE = 2,
    PRIMARY_END = 5,
    COSIGNER_RESIDENCE = 8,
    FINAL_STEP = 11,
}
